import ViewMyUploadPage from './ViewMyUploadPage'
export default ViewMyUploadPage;